import type { TAppUser } from '@core/backend'

export const GUEST_USER: TAppUser = {
    id: 0,
    email: '',
    firstName: '',
    lastName: '',
    joinDate: 0,
    auth: '',
    username: '',
    avatarUrl: '',
    displayName: '',
    plan: '',
    browsableAudioCount: 0,
}
